import { NavLink } from 'react-router-dom';
import { getDocsByGroup, type DocGroupId } from '../content/docs';

const ORDER: DocGroupId[] = ['overview', 'contact', 'shared', 'server'];

interface Props {
  activeSlug?: string;
}

export default function DocsSidebar({ activeSlug }: Props) {
  const groups = getDocsByGroup();
  return (
    <aside className="docs-sidebar" aria-label="Documentation navigation">
      <nav>
        <NavLink
          to="/docs"
          end
          className={({ isActive }) => (isActive ? 'docs-side-home active' : 'docs-side-home')}
        >
          All documents
        </NavLink>
        {ORDER.map((g) => {
          const group = groups[g];
          if (!group.docs.length) return null;
          return (
            <div key={g} className="docs-side-group">
              <div className="docs-side-label">{group.label}</div>
              <ul>
                {group.docs.map((d) => {
                  const selected = activeSlug === d.slug;
                  return (
                    <li key={d.slug}>
                      <NavLink
                        to={`/docs/${d.slug}`}
                        className={({ isActive }) => (isActive || selected ? 'active' : undefined)}
                      >
                        {d.title}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
